export const MASTER_COMPANY_LIST = 'MASTER_COMPANY_LIST'
export const MASTER_COMPANY_LIST_ERROR = 'MASTER_COMPANY_LIST_ERROR'
export const CLEAR_MASTER_COMPANY_ERROR = 'CLEAR_MASTER_COMPANY_ERROR'
export const COMPANY_REQUEST_LIST = 'COMPANY_REQUEST_LIST'
export const UPDATE_COMPANY_REQUEST_STATUS = "UPDATE_COMPANY_REQUEST_STATUS";
